<template>
  <div class="table-wrapper mt-4">
    <div class="container-fluid">
      <h6 class="mb-4">Job History</h6>
      <b-form @submit.prevent inline class="mb-4">
        <label class="sr-only" for="quoteStatus">Status</label>
        <b-form-select
          v-model="filterStatus"
          class="mb-2 mr-sm-2 mb-sm-0"
          id="quoteStatus"
          :options="[
            { value: 'all', text: 'All' },
            { value: 'open', text: 'Open' },
            { value: 'active', text: 'Active' },
            { value: 'due-soon', text: 'Due Soon' },
            { value: 'overdue', text: 'Overdue' },
            { value: 'completed', text: 'Completed' },
          ]"
          @change="filter(1)"
        ></b-form-select>
        <b-form-input
          class="mb-2 mb-sm-0"
          placeholder="Search"
          v-model="filterQuery"
          @change="filter(1)"
        ></b-form-input>
      </b-form>
      <b-table
        :busy="this.$root.loading"
        :items="tableItems"
        :fields="tableFields"
        sort-icon-left
        hover
        responsive
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle" :variant="'primary'"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(action)="row">
          <router-link
            :to="{
              name: 'contractor-quote-view',
              params: { id: row.item['Job ID'] },
            }"
            >View
          </router-link>
        </template>
      </b-table>

      <div class="datagrid-footer" v-if="lastPage > 1">
        <b-pagination
          pills
          align="right"
          :total-rows="total"
          v-model="currentPage"
          :page-count="lastPage"
          :per-page="perPage"
          :hide-goto-end-buttons="true"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

export default {
  data() {
    return {
      currentPage: 1,
      total: 0,
      perPage: 50,
      lastPage: 1,
      tableItems: [],
      tableFields: [
        { key: "Date", sortable: true },
        { key: "Job ID", sortable: true },
        { key: "Address", sortable: true },
        { key: "Status", sortable: true },
        { key: "Action", sortable: false },
      ],
      filterQuery: "",
      filterStatus: "all",
    };
  },
  mounted() {
    this.filter();
  },
  methods: {
    filter(page = 1) {
      axios
        .post("api/contractor/quote/filter", {
          page: page,
          filter_params: this.filterParams,
          filter_status: this.filterStatus,
          filter_query: this.filterQuery,
          sort_field: "id",
          sort_order: "desc",
          per_page: 5,
          load_strata_plan: true,
        })
        .then((response) => {
          this.currentPage = response.data.current_page;
          this.total = response.data.total;
          this.perPage = response.data.per_page;
          this.lastPage = response.data.last_page;
          this.tableItems = _.map(response.data.quotes, function (quote) {
            return {
              Date: moment(quote.created_at).format("D MMM YYYY"),
              "Job ID": quote.id,
              Address: quote.strata_plan.address,
              Status: quote.status_parsed,
              Action: "",
            };
          });
        });
    },
  },
};
</script>
